// NOTE:: THIS IS A SERVERMIDDLEWARE NOT A CLIENT MIDDLEWARE
// https://nuxtjs.org/docs/configuration-glossary/configuration-servermiddleware/

function dedupeSetCookies (setCookieArray) {
  const nameToIndex = new Map()

  setCookieArray.forEach((cookieStr, idx) => {
    const name = cookieStr.split('=')[0].trim()
    nameToIndex.set(name, idx)
  })

  return setCookieArray.filter((cookieStr, idx) => {
    const name = cookieStr.split('=')[0].trim()
    return nameToIndex.get(name) === idx
  })
}

export default function (_, res, next) {
  const originalEnd = res.end

  res.end = function (...args) {
    try {
      // Check for duplicate set-cookie headers
      // Caused by plugins/persistedState.js
      // Too many duplicate set-cookie headers causes the cookie header to be too long for cloudfront
      const headers = res.getHeaders()
      const setCookies = headers['set-cookie']

      if (Array.isArray(setCookies)) {
        const deduped = dedupeSetCookies(setCookies)
        res.setHeader('set-cookie', deduped)
      }

      originalEnd.apply(res, args)
    } catch {
      originalEnd.apply(res, args)
    }
  }

  next()
}
